import React from 'react';

/**
 * PageShell — 모든 페이지 공통 레이아웃 래퍼
 * 
 * Desktop: max-w-6xl, p-6, space-y-6 (전 페이지 통일)
 * 적용 대상: Dashboard, DeviceManager, Visualizer, DataCenter, StreamProcess, Settings, HomePage
 */
interface PageShellProps {
  children: React.ReactNode;
  className?: string;
}

export function PageShell({ children, className = '' }: PageShellProps) {
  return (
    <div className={`p-4 sm:p-6 max-w-6xl mx-auto space-y-6 pb-20 ${className}`}>
      {children}
    </div>
  );
}

/**
 * PageHeader — 모든 페이지 상단 제목 영역 통일
 * 
 * Desktop: lb-display-lg 타이틀 + t-soft 서브타이틀
 * 페이지별 추가 액션(버튼 등)은 children으로 주입
 */
interface PageHeaderProps {
  title: string;
  subtitle?: string;
  className?: string;
  children?: React.ReactNode;
}

export function PageHeader({ title, subtitle, className = '', children }: PageHeaderProps) {
  return (
    <div className={`flex justify-between items-center ${className}`}>
      <div>
        <h1 className="lb-display-lg hidden md:block">{title}</h1>
        {subtitle && <p className="lb-body-lg t-soft mt-1">{subtitle}</p>}
      </div>
      {children && <div className="flex gap-2">{children}</div>}
    </div>
  );
}
